import React, { useEffect, useState } from 'react'
import {
  Col,
  Row,
  Tabs,
  Collapse,
  Avatar,
  List,
  Spin,
  Button,
  Pagination
} from 'antd'
import ds from '../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import Placeholder from '../../assets/images/placeholder.svg'
import {
  closeAttribTabsModal,
  fetchCurrentSalesOrder,
  formatDigits,
  getDecryptID,
  isEmptyObject,
  loadIncomingSale,
  notAllowMsgCheck,
  saleIsInProgress
} from '../../appRedux/actions'
import {
  CaretDownOutlined,
  CaretRightOutlined,
  CaretUpOutlined,
  HistoryOutlined,
  WalletOutlined
} from '@ant-design/icons'
import ParkRetrieveListItem from './ParkRetrieveListItem'
import { GetIndexDBDataByTableName } from '../../appRedux/actions/IndexDBActions'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../constants/IndexDBData'
import moment from 'moment'
import { sum } from 'lodash'

const { Panel } = Collapse

const CardAttribSalesForTabs = props => {
  const { data, setShow, currency, outID } = props
  const dispatch = useDispatch()

  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const dropDownStates = useSelector(
    ({ commonConfigs }) => commonConfigs.dropDownStates
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getIsSpinning, setIsSpinning] = useState(false) // true
  const [saleData, setSaleData] = useState({})
  const [listData, setListData] = useState([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(5)
  const [activeKey, setActiveKey] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      console.log(data)
      if (data && !isEmptyObject(data)) {
        if (data.saleCount && data.saleCount == 1 && data.saleOrderID != '--') {
          onPanelClick([1], data.saleOrderID, 0, data.isOffline)
        }

        if (data.attributeID) {
          const call_body = {
            OutletID: outID,
            SalesOrderStatusID: fetchCurrentSalesOrder('Parked'),
            AttributeID: data.attributeID,
            PageSize: pageSize
          }
          if (isOnline) getSellAttribSaleService(call_body)
          else fetchIndexedAttributeSale(call_body)
        }
      } else {
        setListData([])
        setIsSpinning(false)
        setSaleData({})
        setTotal(0)
        setPage(1)
      }
    }
    return () => {
      mounted = false
    }
  }, [data])

  async function getSellAttribSaleService (body) {
    setLoading(true)
    const getSaleHistoryByID = ds.getBriefSaleService(body)
    await getSaleHistoryByID
      .then(res => {
        setLoading(false)
        fetchIndexedAttributeSale(body, res)
        // saleListEffects(res, isOnline)
      })
      .catch(e => {
        setListData([])
        notAllowMsgCheck(e)
        setLoading(false)
        setPage(1)
        setTotal(0)
      })
  }

  async function getDetailService (body, autoRetrieve) {
    setLoading(true)
    const getSaleHistoryByID = ds.getSaleHistoryByIdService(body)
    await getSaleHistoryByID
      .then(res => {
        setIsSpinning(false)
        setLoading(false)
        if (res && res.length > 0) {
          //marking to identify that the prods coming first time from backend
          const sale = res[0]
          if (sale.products && sale.products.length > 0) {
            sale.products.map(a => (a.firstTime = true))
          }
          setSaleData(sale)
          if (autoRetrieve) handleClickParkedItem(sale)
        } else {
          setSaleData({})
        }
      })
      .catch(e => {
        setSaleData({})
        notAllowMsgCheck(e)
        setIsSpinning(false)
        setLoading(false)
      })
  }

  function fetchIndexedSale (indexKey, autoRetrieve) {
    setIsSpinning(true)
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        setIsSpinning(false)
        if (e && e.length > 0 && indexKey) {
          let parkedSale = e.filter(q => q.indexKey == indexKey)
          if (parkedSale && parkedSale.length > 0) {
            parkedSale.map(q => {
              if (q.products && q.products.length > 0) {
                q.products.map(a => (a.firstTime = true))
              }
            })
            let sale = { ...parkedSale[0] }
            setSaleData(sale)
            if (autoRetrieve) handleClickParkedItem(sale)
          } else {
            setSaleData({})
            setActiveKey('')
          }
        } else {
          setSaleData({})
          setActiveKey('')
        }
      })
      .catch(e => {
        setIsSpinning(false)
        setSaleData({})
        setActiveKey('')
        console.log(
          'INDEX_DB_ERROR -> fetchIndexedSale, attribute parked offline sale -->',
          e
        )
      })
  }

  function fetchIndexedAttributeSale (info, serverResp) {
    setLoading(true)
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        let body = serverResp && serverResp.length > 0 ? serverResp : []
        if (e && e.length > 0) {
          let res = []
          let parkedSale = e.filter(
            q =>
              getDecryptID(q.e_SalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('Parked')) &&
              getDecryptID(q.e_OutletID) == getDecryptID(info.OutletID)
          )
          if (body && body.length > 0) {
            const completedSales = e.filter(
              q =>
                q.isCompleted ||
                getDecryptID(q.e_SalesOrderStatusID) ==
                  getDecryptID(fetchCurrentSalesOrder('Voided'))
            )
            if (completedSales && completedSales.length > 0) {
              completedSales.map(ll => {
                body = body.filter(op => op.index_Key != ll.indexKey)
              })
            }
          }
          if (parkedSale && parkedSale.length > 0) {
            parkedSale = isOnline
              ? parkedSale.filter(a => a.isOffline && !a.isCompleted)
              : parkedSale.filter(a => !a.isCompleted)

            parkedSale.map(re => {
              if (re.sellAttributes && re.sellAttributes.length > 0) {
                const hmm = re.sellAttributes.filter(
                  gg =>
                    getDecryptID(gg.attributeID) ==
                    getDecryptID(info.AttributeID)
                )
                if (hmm && hmm.length > 0) {
                  res.push(re)
                }
              }
            })
          }
          if (res && res.length > 0) {
            let offline_body = res.map(tt => {
              return {
                totalRecords: res.length,
                totalPrice: tt.totalPriceExc,
                createdOn: tt.operateDateTime,
                index_Key: tt.indexKey,
                receiptCode: tt.receiptCode,
                saleOrderID: tt.e_SalesOrderID,
                indexOffline: tt.isOffline,
                index_isAllPaid: tt.isAllPaid
              }
            })
            offline_body.map(te => {
              if (te.indexOffline) {
                body = body.filter(xz => xz.index_Key != te.index_Key)
              }
              body.push(te)
            })
          }
        }
        saleListEffects(body)
      })
      .catch(e => {
        saleListEffects(serverResp)
        setListData([])
        notAllowMsgCheck(e)
        setLoading(false)
        setPage(1)
        setTotal(0)
        console.log(
          'INDEX_DB_ERROR -> fetchIndexedAttributeSale attribute fetch sale list -->',
          e
        )
      })
  }

  function saleListEffects (res) {
    setLoading(false)
    if (res && res.length > 0) {
      let total = res[0].totalRecords ? res[0].totalRecords : 0
      let body = res.map(w => {
        return {
          amount: sum([
            w.totalPrice ? w.totalPrice : 0,
            w.totalTax ? w.totalTax : 0
          ]),
          createdOn: w.createdOn,
          indexKey: w.index_Key,
          receiptCode: w.receiptCode,
          saleOrderID: w.key ? getDecryptID(w.key) : 0,
          isOffline: w.indexOffline || !isOnline ? w.index_Key : false
        }
      })
      setListData(body)
      setTotal(total)
    } else {
      setTotal(0)
      setListData([])
      setPage(1)
    }
  }

  function onPanelClick (e, id, key, isOffline, autoRetrieve) {
    if (e && e.length > 0 && (id || isOffline)) {
      setSaleData({})
      setActiveKey(key)
      setIsSpinning(true)
      let body = {
        OutletID: '',
        SalesOrderID: `${id}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
        SalesOrderStatusID: '',
        CustomerID: '',
        UserID: '',
        IsRetrieve: true
      }
      if (isOffline) fetchIndexedSale(isOffline, autoRetrieve)
      else getDetailService(body, autoRetrieve)
    } else {
      setSaleData({})
      setActiveKey('')
    }
  }

  function onRetClick (f, key) {
    onPanelClick([1], f.saleOrderID, key, f.isOffline, true)
  }

  function showTotal (total) {
    return `Total ${total} Sales`
  }

  function onPageChange (e) {
    let currPage = e
    setPage(currPage)
    getSellAttribSaleService({
      OutletID: outID,
      SalesOrderStatusID: fetchCurrentSalesOrder('Parked'),
      AttributeID: data.attributeID,
      PageSize: pageSize,
      CurrentPageNo: currPage
    })
  }

  const handleClickParkedItem = selectedParkedSaleData => {
    if (!isEmptyObject(selectedParkedSaleData)) {
      if (!isEmptyObject(getCurrentSalesOrderData)) {
        saleIsInProgress(dispatch, selectedParkedSaleData)
      } else {
        loadIncomingSale(selectedParkedSaleData, dispatch)
      }
    }
    closeAttribTabsModal(dispatch, dropDownStates)
  }

  return (
    <div className='receipt-accordion-wrapper'>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={loading || getIsSpinning}
        size='large'
      >
        {listData &&
          listData &&
          listData.length > 0 &&
          listData.map((f, key) => {
            let hourDiff = 0
            let minDiff = 0
            if (f && f.createdOn) {
              const startTime = new Date(f.createdOn)
              const endTime = new Date()
              const timeDifference = endTime - startTime
              hourDiff = Math.floor(timeDifference / (1000 * 60 * 60))
              minDiff = Math.floor(
                (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
              )
            }
            return (
              <Collapse
                activeKey={activeKey}
                onChange={e => {
                  onPanelClick(e, f.saleOrderID, key, f.isOffline)
                }}
              >
                <Panel
                  key={key}
                  className='receipt-accordion'
                  showArrow={false}
                  header={
                    <div className='Receipt-head align-items-center justify-content-between'>
                      <div className='Receipt-no-cols'>
                        <div className='Receipt-chunks'>
                          {f &&
                          !isEmptyObject(saleData) &&
                          f.indexKey == saleData.indexKey ? (
                            <CaretDownOutlined />
                          ) : (
                            <CaretRightOutlined />
                          )}
                          <span className='strong'>
                            Receipt:
                            {f.receiptCode
                              ? ` ${f.receiptCode}`
                              : ` ${key + 1}`}
                          </span>
                        </div>

                        <div className='Receipt-chunks'>
                          <HistoryOutlined />
                          <span>
                            {hourDiff < 10 ? `0${hourDiff}` : hourDiff}:
                            {minDiff < 10 ? `0${minDiff}` : minDiff}
                          </span>
                        </div>

                        <div className='Receipt-chunks'>
                          <span>
                            {currency && currency.currencySymbol ? (
                              <span className='mx-0'>
                                {currency.currencySymbol}
                              </span>
                            ) : (
                              <WalletOutlined />
                            )}
                            {formatDigits(f.amount, 2)}
                          </span>
                        </div>

                        <div className='Receipt-chunks'>
                          <span>
                            {moment(f.createdOn).format(
                              'MMMM Do YYYY, h:mm:ss a'
                            )}
                          </span>
                        </div>
                      </div>

                      <Button
                        type='primary'
                        className='Retrieve-btns btn-reversed'
                        onClick={() => {
                          onRetClick(f, key)
                        }}
                      >
                        Retrieve
                      </Button>
                    </div>
                  }
                >
                  <Spin
                    tip={<IntlMessages id='sell.cashlisting.cashloading' />}
                    spinning={false} // getIsSpinning
                    size='large'
                  >
                    {saleData && !isEmptyObject(saleData) ? (
                      <ParkRetrieveListItem
                        retrieveItem={saleData}
                        type='attrib'
                      />
                    ) : (
                      <List.Item className='cursor-pointer'>
                        <List.Item.Meta
                          avatar={
                            <Avatar
                              src={Placeholder}
                              className='dk-avatar-retrive-sale'
                            />
                          }
                          // {retrieveItem.quantity}
                          title={
                            <div className='custom-inline'>
                              {/* <p className='custom-div-show ant-custom-mb-auto'>
                                {'1'}
                                {' × '}
                                {'Name'}
                              </p>
                              <p className='custom-div-show ant-custom-mb-auto'>
                                {'2'}
                                {' × '}
                                {'Name'}
                              </p>
                              <p className='custom-div-show ant-custom-mb-auto'>
                                {'3'}
                                {' × '}
                                {'Name'}
                              </p> */}
                            </div>
                          }
                          description={
                            <>
                              <Row>
                                <Col span={24}>
                                  <p>
                                    <IntlMessages id='sell.sell.retrievesell.parkedabout' />{' '}
                                    {'Date'}{' '}
                                    <IntlMessages id='sell.sell.retrievesell.by' />{' '}
                                    {`User System`}
                                  </p>
                                </Col>
                              </Row>
                            </>
                          }
                        />
                      </List.Item>
                    )}
                  </Spin>
                </Panel>
              </Collapse>
            )
          })}
        {isOnline && total ? (
          <Pagination
            className='theme-Pagination mt-4'
            size='small'
            total={total}
            pageSize={pageSize}
            showTotal={showTotal}
            onChange={onPageChange}
          />
        ) : (
          ''
        )}
      </Spin>
    </div>
  )
}

export default CardAttribSalesForTabs
